import { render, staticRenderFns } from "./ChufangDetail.vue?vue&type=template&id=a6340fd8"
import script from "./ChufangDetail.vue?vue&type=script&lang=js"
export * from "./ChufangDetail.vue?vue&type=script&lang=js"
import style0 from "./ChufangDetail.vue?vue&type=style&index=0&id=a6340fd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports